import { Select } from 'antd';
import RestFieldItem from 'components/RestField/RestFieldItem';
import List from 'containers/rest/List';

const CareerRequestsList = (props) => (
  <List {...props} resource="careerRequests">
    <RestFieldItem
      width={150}
      source="fullName"
      header="careerRequests.fullName"
    />
    <RestFieldItem
      width={150}
      source="desiredField"
      header="careerRequests.desiredField"
    />
    <RestFieldItem
      width={120}
      source="phoneNumber"
      header="careerRequests.phoneNumber"
    />
    <RestFieldItem width={180} source="email" header="careerRequests.email" />
    <RestFieldItem
      width={200}
      source="description"
      header="careerRequests.description"
    />
    <RestFieldItem
      width={150}
      source="cvUrl"
      header="careerRequests.cvUrl"
      render={(value) =>
        value ? (
          <a href={value} target="_blank" rel="noopener noreferrer">
            View CV
          </a>
        ) : (
          'N/A'
        )
      }
    />
    <RestFieldItem
      valueProp="value"
      fixed="right"
      component={
        <Select
          options={[
            { label: 'Pending', value: 'pending' },
            { label: 'Contacted', value: 'contacted' },
            { label: 'In Progress', value: 'in_progress' },
            { label: 'Completed', value: 'completed' },
            { label: 'Rejected', value: 'rejected' },
          ]}
        ></Select>
      }
      source="status"
      header="careerRequests.status"
    />
  </List>
);

CareerRequestsList.propTypes = {};

export default CareerRequestsList;
